import { render } from "./InputDate.vue?vue&type=template&id=008cfeb6&scoped=true"
import script from "./InputDate.vue?vue&type=script&lang=js"
export * from "./InputDate.vue?vue&type=script&lang=js"

import "./InputDate.vue?vue&type=style&index=0&id=008cfeb6&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008cfeb6"]])

export default __exports__